import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export const PremiumLoader = ({ message = "Creating your masterpiece..." }) => (
  <motion.div data-testid="premium-loader" className="flex flex-col items-center justify-center py-8" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
    <div className="relative w-20 h-20 mb-4">
      <motion.div className="absolute inset-0 border-2 border-gold/30 rounded-full" animate={{ rotate: 360 }} transition={{ duration: 3, repeat: Infinity, ease: "linear" }} />
      <motion.div className="absolute inset-2 border-2 border-gold/50 rounded-full" animate={{ rotate: -360 }} transition={{ duration: 2, repeat: Infinity, ease: "linear" }} />
      <motion.div className="absolute inset-4 border-2 border-gold rounded-full" animate={{ rotate: 360 }} transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }} />
      <Sparkles className="absolute inset-0 m-auto w-5 h-5 text-gold" />
    </div>
    <motion.p className="text-white/70 text-sm" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 2, repeat: Infinity }}>
      {message}
    </motion.p>
  </motion.div>
);
